module.exports = __webpack_public_path__ + "static/media/logo.16925e32.svg";